angular.module('signalview.chartbuilder').controller('SectionsCtrl', [
    '$scope',
    function ($scope) {
        let previousTab;
        const ENTITY_TAB_ID = 'entity';
        let hasPendingEntityTypeChange = false;

        $scope.entityTabNotificationType = undefined;

        function updateEntityTabNotification() {
            const isEntityTabSelected =
                $scope.selectedTab && $scope.selectedTab.id === ENTITY_TAB_ID;
            if (isEntityTabSelected) {
                $scope.entityTabNotificationType = undefined;
            } else if (hasPendingEntityTypeChange) {
                $scope.entityTabNotificationType = 'updated';
            } else if ($scope.entityTypeSelectionValid === false) {
                $scope.entityTabNotificationType = 'error';
            } else {
                $scope.entityTabNotificationType = undefined;
            }
        }

        function setSelectedTab(tab) {
            previousTab = $scope.selectedTab;
            $scope.selectedTab = tab;
            if (!previousTab || tab.id !== previousTab.id) {
                $scope.$emit('tab selected', $scope.selectedTab.id);
            } else {
                $scope.$emit('clicked active tab');
            }
            if (tab.id === ENTITY_TAB_ID) {
                hasPendingEntityTypeChange = false;
            }
            updateEntityTabNotification();
        }

        setSelectedTab($scope.toSelectTab || $scope.sectionTabs[0]);

        $scope.selectTab = function (tab) {
            if (!tab.disabled) {
                setSelectedTab(tab);
            }
        };

        $scope.$on('entity type changed', function () {
            if ($scope.selectedTab && $scope.selectedTab.id !== ENTITY_TAB_ID) {
                hasPendingEntityTypeChange = true;
            }
            updateEntityTabNotification();
        });

        $scope.$watch('entityTypeSelectionValid', function () {
            updateEntityTabNotification();
        });

        function goToTab(id) {
            $scope.sectionTabs.some(function (tab) {
                if (tab.id === id && !tab.disabled) {
                    setSelectedTab(tab);
                    return true;
                }
                return false;
            });
        }

        $scope.$on('go to tab', function (ev, id) {
            goToTab(id);
        });

        function goToPreviousTab() {
            if (!previousTab) {
                return;
            }
            const newTab = previousTab;
            previousTab = $scope.selectedTab;
            goToTab(newTab.id);
        }

        $scope.$on('go to previous tab', goToPreviousTab);

        // Move off current tab if it is disabled, to the given one
        $scope.$on('leave disabled tab', function (ev, id) {
            if ($scope.selectedTab && $scope.selectedTab.disabled) {
                goToTab(id);
            }
        });
    },
]);
